import { lazy, memo, Suspense, useCallback, useState } from 'react';

import Tippy from '@tippyjs/react';
import { FiSmile } from 'react-icons/fi';

import * as S from './styles';

const EmojiPicker = lazy(() => import('emoji-picker-react'));

type EmojiPickerPopoverProps = {
  onEmojiSelect: (emoji: string) => void;
  size?: 'default' | 'small';
};

const EmojiPickerPopover = ({
  onEmojiSelect,
  size = 'default',
}: EmojiPickerPopoverProps) => {
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleEmojiClick = useCallback(
    (emojiData: { emoji: string }) => {
      onEmojiSelect(emojiData.emoji);
    },
    [onEmojiSelect],
  );

  const handleToggle = useCallback(() => {
    if (!loaded) setLoaded(true);
    setVisible((prev) => !prev);
  }, [loaded]);

  const iconSize = size === 'small' ? '1rem' : '1.25rem';

  return (
    <Tippy
      content={
        loaded ? (
          <S.PickerWrapper>
            <Suspense fallback={null}>
              <EmojiPicker
                onEmojiClick={handleEmojiClick}
                width={320}
                height={380}
                searchPlaceholder="Buscar emoji..."
                previewConfig={{ showPreview: false }}
              />
            </Suspense>
          </S.PickerWrapper>
        ) : (
          <span />
        )
      }
      visible={visible}
      onClickOutside={() => setVisible(false)}
      interactive
      trigger="manual"
      placement="top-start"
      appendTo={document.body}
      animation={false}
    >
      <S.EmojiButton
        type="button"
        onClick={handleToggle}
        title="Emoji"
        $small={size === 'small'}
      >
        <FiSmile size={iconSize} />
      </S.EmojiButton>
    </Tippy>
  );
};

export default memo(EmojiPickerPopover);
